// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarSkeleton_GiHamburgerMenu__Dq2cu {
  background-color: var(--border-green);
  color: var(--black-color);
  font-size: 30px;
}

.SideBarSkeleton_headerContainer__JtsJQ {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 24px;
  background: transparent;
}

.SideBarSkeleton_mainContainer__R1Diy {
  max-width: 100% !important;
  height: 100vh;
  overflow-y: auto;
}

.SideBarSkeleton_sidebarDiv__NnRxi {
  width: 300px;
}

.SideBarSkeleton_contentDiv__6x4Bs {
  width: calc(100% - 300px);
  height: 100vh;
  overflow-y: auto;
}

.SideBarSkeleton_childDiv__O3REX {
  margin-top: 32px;
  padding-inline: 24px;
}

@media screen and (max-width: 1024px) {
  .SideBarSkeleton_headerContainer__JtsJQ {
    background-color: var(--border-green);
  }
  .SideBarSkeleton_childDiv__O3REX {
    margin-top: 16px;
    padding-inline: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/atoms/SideBarSkeleton/SideBarSkeleton.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF","sourcesContent":[".GiHamburgerMenu {\n  background-color: var(--border-green);\n  color: var(--black-color);\n  font-size: 30px;\n}\n\n.headerContainer {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-inline: 24px;\n  background: transparent;\n}\n\n.mainContainer {\n  max-width: 100% !important;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.sidebarDiv {\n  width: 300px;\n}\n\n.contentDiv {\n  width: calc(100% - 300px);\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.childDiv {\n  margin-top: 32px;\n  padding-inline: 24px;\n}\n\n@media screen and (max-width: 1024px) {\n  .headerContainer {\n    background-color: var(--border-green);\n  }\n  .childDiv {\n    margin-top: 16px;\n    padding-inline: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GiHamburgerMenu": `SideBarSkeleton_GiHamburgerMenu__Dq2cu`,
	"headerContainer": `SideBarSkeleton_headerContainer__JtsJQ`,
	"mainContainer": `SideBarSkeleton_mainContainer__R1Diy`,
	"sidebarDiv": `SideBarSkeleton_sidebarDiv__NnRxi`,
	"contentDiv": `SideBarSkeleton_contentDiv__6x4Bs`,
	"childDiv": `SideBarSkeleton_childDiv__O3REX`
};
export default ___CSS_LOADER_EXPORT___;
